import { DictUtil } from 'jczh-ui'

export const articleAliasDict = new DictUtil({
  PRODUCT_NOTICE: {
    label: '产品公告',
    value: 'CPGG',
    alias: 'CPGG'
  },
  NEWS: {
    label: '新闻中心',
    value: 'XWZX',
    alias: 'XWZX'
  },
  INDUSTRY_NEWS: {
    label: '行业资讯',
    value: 'HYZX',
    alias: 'HYZX'
  },
  INDUSTRY_NEWS_ARTICLE: {
    label: '行业资讯推荐文章',
    value: 'HYWZTJ',
    alias: 'HYWZTJ'
  },
  FAQ: {
    label: '常见问题',
    value: 'CJWT',
    alias: 'CJWT'
  },
  OPERATE_MANUAL: {
    label: '操作手册',
    value: 'CZSC',
    alias: 'CZSC'
  },
  QUICK_START: {
    label: '快速入门',
    value: 'KSRM',
    alias: 'KSRM'
  },
  DEMAND_RESEARCH: {
    label: '需求调查',
    value: 'XQDC',
    alias: 'XQDC'
  },
  EXPERT_MANAGE_RULES: {
    label: '专家管理制度',
    value: 'ZJGL',
    alias: 'ZJGL'
  },
  EXPERT_NOTICE: {
    label: '专家公告通知',
    value: 'ZJGG',
    alias: 'ZJGG'
  },
  EXPERT_DOWNLOAD: {
    label: '专家相关下载',
    value: 'ZJXGXZ',
    alias: 'ZJXGXZ'
  },
  VALUE_ADDED_FAQ: {
    label: '会员常见问题答疑',
    value: 'VAFAQ',
    alias: 'VAFAQ'
  },
  Agreement_TERM: {
    label: '协议条款',
    value: 'VAS',
    alias: 'VAS'
  }
})
